import {NextApi} from "../Next/next";

export const OPERATORS_GET = 'OPERATORS_GET'

export const getOperatorsNext = new NextApi( '/whitelabel/operators', OPERATORS_GET, {
  method: 'GET', json: false,
});

